/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DisplayInputs */

const en_display = /** @type {(inputs: DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display`)
};

const fr_display = /** @type {(inputs: DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affichage`)
};

const de_display = /** @type {(inputs: DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeige`)
};

const it_display = /** @type {(inputs: DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display`)
};

const ru_display = /** @type {(inputs: DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отображать`)
};

const es_display = /** @type {(inputs: DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar`)
};

const zh_cn2_display = /** @type {(inputs: DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`展示`)
};

const ja_display = /** @type {(inputs: DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面`)
};

const hi_display = /** @type {(inputs: DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रदर्शन`)
};

const pt_pt2_display = /** @type {(inputs: DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar`)
};

/**
* | output |
* | --- |
* | "Display" |
*
* @param {DisplayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const display = /** @type {((inputs?: DisplayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DisplayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_display(inputs)
	if (locale === "de") return de_display(inputs)
	if (locale === "it") return it_display(inputs)
	if (locale === "ru") return ru_display(inputs)
	if (locale === "es") return es_display(inputs)
	if (locale === "zh-CN") return zh_cn2_display(inputs)
	if (locale === "ja") return ja_display(inputs)
	if (locale === "hi") return hi_display(inputs)
	if (locale === "pt-PT") return pt_pt2_display(inputs)
	return en_display(inputs)
});